export default __webpack_public_path__ + "static/promo-modal-soc-mobile-d450db5675131727dc2e0bb3a65fe4a6.png";